import React from "react";
import { Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Banner from "../../components/banner/banner";
import "../../components/button/button.css";

const Error = () => {
    const navigate = useNavigate();
  return (
    <Container
      style={{ backgroundColor: "#E4F4F3", height: "100vh" }}
      className="text-center p-0"
    >
      <Banner />
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{ height: "80%" }}
      >
        <p className="h1">
          <b>無法偵測Line帳戶</b>
        </p>
        <br />
        <Button className="btn-custom-green" style={{ width: "50%" }} onClick={() => {navigate("/main")}}>
          在試一次
        </Button>
      </div>
    </Container>
  );
};

export default Error;
